var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextShaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8935 0.3909H3.20416C1.88002 0.3909 0.802734 1.46818 0.802734 2.79233V8.76922C0.802734 10.0934 1.88002 11.1706 3.20416 11.1706H18.8935C20.2176 11.1706 21.2949 10.0934 21.2949 8.76922V2.79233C21.2949 1.46818 20.2176 0.3909 18.8935 0.3909ZM19.694 8.76922C19.694 9.2106 19.3349 9.56969 18.8935 9.56969H3.20416C2.76278 9.56969 2.40369 9.2106 2.40369 8.76922V2.79233C2.40369 2.35095 2.76278 1.99185 3.20416 1.99185H18.8935C19.3349 1.99185 19.694 2.35095 19.694 2.79233V8.76922Z",
    fill: "#677C95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.694 8.76922C19.694 9.2106 19.3349 9.56969 18.8935 9.56969H3.20416C2.76278 9.56969 2.40369 9.2106 2.40369 8.76922V2.79233C2.40369 2.35095 2.76278 1.99185 3.20416 1.99185H18.8935C19.3349 1.99185 19.694 2.35095 19.694 2.79233V8.76922ZM5.61206 4.9803H10.2381C10.6802 4.9803 11.0386 5.33868 11.0386 5.78077C11.0386 6.22286 10.6802 6.58125 10.2381 6.58125H5.61206C5.16997 6.58125 4.81158 6.22286 4.81158 5.78077C4.81158 5.33868 5.16997 4.9803 5.61206 4.9803Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextShaded);
export default __webpack_public_path__ + "static/media/text-shaded.5298a3a9d3102be57b2877d6893fdefd.svg";
export { ForwardRef as ReactComponent };